import Hr from "PFComponents/hr/hr";
import { Tile } from "PFComponents/tile";
import { Activity } from "PFCore/types/activity";
import { EconomicsScenarioDetails } from "PFCore/types/economics_scenarios";

import { BudgetVsCostChart } from "./charts/budget_vs_cost_chart";
import { GradeChart } from "./charts/grade_chart";
import { HoursChart } from "./charts/hours_chart";
import { SkillsChart } from "./charts/skills_chart";
import css from "./scenario_view.module.scss";

type ScenarioSummaryProps = {
  activity: Activity;
  scenario: EconomicsScenarioDetails;
};

export const ScenarioSummary = ({ activity, scenario }: ScenarioSummaryProps) => (
  <Tile paddingVariant="lg" variant="selected" className={css.sidebar}>
    <BudgetVsCostChart
      className={css.budgetCostChart}
      budget={activity.metadata.budget}
      cost={scenario.cost}
    />
    {!!scenario?.skillsRadarData && (
      <>
        <Hr />
        <SkillsChart
          skillsRadarData={scenario.skillsRadarData}
          skillsCoveredPercentage={scenario.skillsCoveredPercentage}
        />
      </>
    )}
    {!!scenario?.durationInHours && (
      <>
        <Hr />
        <HoursChart hoursTotal={scenario.durationInHours} coverage={scenario.hoursCoveredPercentage} />
      </>
    )}
    {!!scenario?.costFieldData?.length && (
      <>
        <Hr />
        <GradeChart data={scenario.costFieldData} activity={activity} />
      </>
    )}
  </Tile>
);
